import styled from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";
import { rawColors } from "../../../design-system/tokens/colors";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { SectionBody } from "../../organisms/StoryBuilder/StoryBuilder.styles";

export const KeyAreasSectionBody = styled(SectionBody)`
  display: flex;
  flex-direction: column;
  gap: ${spacing[2]};
`;

export const KeyAreaBody = styled.div`
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  min-width: 0;
`;

export const KeyAreaDetail = styled.p`
  margin: 0;
  word-break: break-word;
  ${typographyMixin("caption", 4)}
  color: ${rawColors.text.mediumEmphasis};
`;

export const CannotAnswer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[1]};
`;

export const CannotAnswerTitle = styled.p`
  margin: 0;
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.highEmphasis};
`;
